import script from "./UsersList.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsersList.vue?vue&type=script&lang=ts&setup=true"

import "./UsersList.vue?vue&type=style&index=0&id=7d56e88b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d56e88b"]])

export default __exports__